"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _VerifiedUserOutlined = _interopRequireDefault(require("@material-ui/icons/VerifiedUserOutlined"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _JmmLoader = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/JmmLoader"));

require("react-phone-number-input/style.css");

var _functions = require("@jobmatchme/ui/es/utils/functions");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PhoneInput = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: 'PhoneInput' */
  'react-phone-number-input');
});
var MuiInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
    type: "tel",
    fullWidth: true,
    endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
      position: "end",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifiedUserOutlined.default, {
        color: "primary",
        className: _styleModule.default.icon
      })
    }),
    inputProps: (0, _extends2.default)({}, props, {
      onChange: function onChange(e) {
        var target = e.target;

        if (target.value && target.value.startsWith('00')) {
          ;
          e.target.value = target.value.replace(/^.{2}/g, '+');
        }

        props.onChange(e);
      }
    }),
    value: props.value,
    inputRef: ref
  });
});
var countryCodes = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];

var SinglePhone = function SinglePhone(_ref) {
  var config = _ref.config;

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var t = (0, _useOurTranslation.useComponentTranslation)(config);
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useState = (0, _react.useState)(context[config.valueName].value || ''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      validator = _useState4[0],
      setValidator = _useState4[1];

  (0, _react.useEffect)(function () {
    if (typeof validator === 'undefined') {
      import(
      /* webpackChunkName: 'PhoneInput' */
      'react-phone-number-input').then(function (exp) {
        return setValidator(function () {
          return exp.isPossiblePhoneNumber;
        });
      });
    }
  }, [validator]);
  (0, _react.useEffect)(function () {
    setValue(config.valueName, typeof inputValue === 'string' && typeof validator !== 'undefined' && validator(inputValue) ? inputValue : undefined);
  }, [config.valueName, inputValue, setValue, validator]);
  var defaultLocale = countryCodes.includes((0, _functions.getLocale)().toUpperCase()) ? (0, _functions.getLocale)().toUpperCase() : 'DE';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      text: t(config.translations.hint),
      textColor: "light"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.textField,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
        fullWidth: true,
        variant: "outlined",
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, _styleModule.default.withSelect, !!config.selectBox)),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
          className: _styleModule.default.label,
          htmlFor: "".concat(config.valueName, "-input"),
          children: t(config.translations.inputField)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PhoneInput, {
            withCountryCallingCode: true,
            countries: countryCodes,
            inputComponent: MuiInput,
            defaultCountry: defaultLocale,
            placeholder: "",
            value: inputValue,
            onChange: setInputValue
          })
        })]
      })
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(SinglePhone);

exports.default = _default;